<template>
  <v-card tile flat class="create-new-banner px-3" :color="$vuetify.theme.dark ? '#172233' : '#e8f1f8'">
    <v-card-title>Uploaded Banner Image</v-card-title>
    <v-row dense>
      <v-col lg="7" md="6" sm="12" cols="12">
        <v-card-text class="pb-0">
          <v-radio-group v-model="ex1" row class="mt-0">
            <v-radio label="For Partner" value="full-control" color="teal" class="custom-radio-buttons"
              :ripple="false"></v-radio>
            <v-radio label="For Client" value="read-only" color="teal" class="custom-radio-buttons"
              :ripple="false"></v-radio>
            <v-radio label="For All" value="no-access" color="teal" class="custom-radio-buttons"
              :ripple="false"></v-radio>
          </v-radio-group>
        </v-card-text>
        <div class="profileView px-3 mb-3">
          <v-card class="verification-card" flat tile :color="$vuetify.theme.dark ? '#1A2A3E' : '#F1F7FB'">
            <v-card-actions class="px-0">
              <v-card-title class="pl-1">
                <v-icon class="pr-2" color="#708AA7">mdi mdi-account-outline</v-icon>Upload Banner
              </v-card-title>
            </v-card-actions>

            <v-card-subtitle class="mx-auto text-center">
              Upload Image in .png or .jpg file <br />
              Our Recommended image Size is 350 * 160
            </v-card-subtitle>
            <div class="zone-wrapper" v-if="$canRoute('banner-upload') === 1">
              <v-card-text class="text-center">
                <vue-dropzone ref="myVueDropzone" id="dropzone" :options="dropzoneOptions"></vue-dropzone>
                <div class="dropzone-content">
                  <v-icon large class="mb-3" color="#708AA7">mdi mdi-tray-arrow-up</v-icon>
                  <p class="mb-0">Drop File Here or <strong>Browse</strong></p>
                  <span>File size max 5MB</span>
                </div>
              </v-card-text>
            </div>
          </v-card>
        </div>
        <div class="global-fieldset px-3">
          <fieldset class="mb-3">
            <legend>Banner Title</legend>
            <v-text-field v-model="BannerTitle" label="Write Here" single-line solo dense hide-details
              class="custom-select"></v-text-field>
          </fieldset>
          <fieldset class="mb-3">
            <legend>Learn More Link</legend>
            <v-text-field v-model="LearnMoreLink" label="input redirect link" single-line solo dense hide-details
              class="custom-select"></v-text-field>
          </fieldset>
        </div>
        <div class="global-fieldset px-3 mb-1">
          <v-row dense align="center">
            <v-col cols="12" sm="12" md="12" lg="6">
              <fieldset class="mb-3">
                <legend>
                  <i class="fa fa-lastfm-square" aria-hidden="true"></i> Banner
                  Show Date
                </legend>
                <v-dialog ref="dialog" v-model="modal" :return-value.sync="date" persistent width="290px">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field v-model="dateRangeText" prepend-icon="mdi-calendar" append-icon="mdi-chevron-down"
                      readonly v-bind="attrs" v-on="on" solo class="custom-select mt-0" hide-details
                      dense></v-text-field>
                  </template>
                  <v-date-picker v-model="date" class="custom-date-picker" scrollable range>
                    <v-spacer></v-spacer>
                    <v-btn :color="$vuetify.theme.dark ? '#ff567f' : '#ff567f'" text @click="modal = false">
                      Cancel
                    </v-btn>
                    <v-btn :color="$vuetify.theme.dark ? '#fff' : '#131c29'" text @click="$refs.dialog.save(date)">
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-dialog>
              </fieldset>
            </v-col>
            <v-col cols="12" sm="12" md="12" lg="6">
              <v-radio-group v-model="ex2" row class="mt-0">
                <v-radio label="Show Always" value="full-control" color="teal" class="custom-radio-buttons mt-3 ml-1"
                  :ripple="false"></v-radio>
                <v-radio label="Visibility Stop" value="read-only" color="teal" class="custom-radio-buttons mt-3 mr-3"
                  :ripple="false"></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
        </div>
        <div class="px-3 mb-6" v-if="$canRoute('banner-upload') === 1">
          <v-btn :ripple="false" tile elevation="0" class="custom-btn mr-3" color="#039de9">
            Submit Banner
          </v-btn>
        </div>
      </v-col>
      <v-col lg="5" md="6" sm="12" cols="12">
        <v-card-text class="pb-7 pl-0">
          <span class="subtitle">Your Banner Live View</span>
        </v-card-text>
        <v-img class="large-image" src="@/assets/banner-new.png">
          <v-card tile flat class="image-wrapper px-3 mx-0" :color="$vuetify.theme.dark ? '#1a2a3d' : '#e8f1f8'">
            <v-row dense no-gutters align="center">
              <v-col cols="12" sm="12" md="12" lg="8">
                <v-card-subtitle>
                  Invite friends & earn together
                  <a class="text-capitalize d-block">
                    Learn Details
                  </a>
                </v-card-subtitle>
              </v-col>
              <v-col cols="12" sm="12" md="12" lg="4">
                <v-img max-height="68" max-width="154" contain class="small-img"
                  src="@/assets/banner-small.png"></v-img>
              </v-col>
            </v-row>
          </v-card>
        </v-img>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import { mapActions, mapState } from "vuex";
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";

export default {
  name: "dropzoneView",
  data() {
    return {
      ex1: "full-control",
      ex2: "full-control",
      BannerTitle: "",
      LearnMoreLink: "",
      dropzoneOptions: {
        url: "https://httpbin.org/post",
        thumbnailWidth: 100,
        maxFilesize: 0.5,
        headers: { "My-Awesome-Header": "header value" },
      },
      modal: false,
      dialog: false,
      date: ["2022-01-01", "2023-01-01"],
    };
  },

  components: {
    vueDropzone: vue2Dropzone,
  },

  computed: {
    dateRangeText() {
      return this.date.join(" ~ ");
    },
    ...mapState("admins", ["loggedAdmin"]),
  },
};
</script>
